module.exports = __webpack_public_path__ + "NotoSansKR-Light-Hestia.07341.woff";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/fonts/woff/NotoSansKR-Light-Hestia.woff
// module id = ./src/_asset/sources/assets/fonts/woff/NotoSansKR-Light-Hestia.woff
// module chunks = main